import type {
  Cart,
  CartProductPrice,
} from '@/clients/storefront/storefront.types';

export const getFormattedPrice = (
  price: CartProductPrice | undefined,
  quantity: number
): string => {
  if (!price?.amount) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: price.currencyCode,
  }).format(parseFloat(price.amount as string) * quantity);
};

export const getFormattedSubtotal = (cart: Cart | null): string => {
  if (!cart?.cost?.subtotalAmount) {
    return '-';
  }

  const subtotal = cart.cost.subtotalAmount;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: subtotal.currencyCode,
  }).format(parseFloat(subtotal.amount as string));
};
